// extracted by mini-css-extract-plugin
export var blue = "bw_fG";
export var button = "bw_ct";
export var label = "bw_cX";
export var orange = "bw_fH";
export var white = "bw_fJ";